module.exports = "/_next/static/images/car-4ab344567d663e29d640b5393a07de7b.svg";